<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../../services/http';
	//Stores
		import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Button, Checkbox, Toggle } from '@Shelly/shelly-design-system';
	//Components
	import MotionBlindTime from './MotionBlindTime.svelte';
	import MotionDetectionOperatingMode from './MotionDetectionOperatingMode.svelte';
	import MotionPulseCount from './MotionPulseCount.svelte';
	import MotionSensitivity from './MotionSensitivity.svelte';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	import type { Device } from '../../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore.motion,
		save = async () => {
			if ($showNewLayout) {
				waitForSaveResponse = true;
				const res: SettingRequest[] = await Promise.all([
					blindTime.save(),
					operatingMode.save(),
					pulseCount.save(),
					sensitivity.save(),
				]);
				onSettingsResponse(res, device);
				waitForSaveResponse = false;
				return;
			}

			waitForResponse = true;
			let res: SettingRequest | SettingRequest[] = await postReq(`/device/generic_command`, {
				id,
				command: `motion_enable`,
				payload: `{"value":${Number(checked)}}`,
			});
			if (res.isok && checked) {
				res = await Promise.all([
					blindTime.save(),
					operatingMode.save(),
					pulseCount.save(),
					sensitivity.save(),
				]);
			}
			onSettingsResponse(res, device);
			waitForResponse = false;
		},
		onToggleChange = async () => {
			waitForToggleResponse = true;
			const res: SettingRequest = await postReq(`/device/generic_command`, {
				id,
				command: `motion_enable`,
				payload: `{"value":${Number(checked)}}`,
			});
			onSettingsResponse(res, device);
			waitForToggleResponse = false;
		};

	let checked = settings.enabled,
		error: false,
		waitForToggleResponse = false,
		waitForSaveResponse = false,
		waitForResponse = false,
		blindTime: MotionBlindTime,
		operatingMode: MotionDetectionOperatingMode,
		pulseCount: MotionPulseCount,
		sensitivity: MotionSensitivity;
</script>

{#if $showNewLayout}
	<Toggle size="m" class="mb-s-plus pb-0" bind:checked id="toggle-hhgnwjz" on:click={onToggleChange}>
		{$format('enable_motion_sensor_label', {
			default: 'Motion detection',
		})}
	</Toggle>

	{#if checked}
		<MotionBlindTime bind:this={blindTime} bind:error disabled={!checked} {device} />
		<MotionDetectionOperatingMode bind:this={operatingMode} disabled={!checked} {device} />
		<MotionPulseCount bind:this={pulseCount} bind:error disabled={!checked} {device} />
		<MotionSensitivity disabled={!checked} bind:this={sensitivity} {device} />
		<Button
			size="m"
			width="full"
			loading={waitForSaveResponse}
			disabled={error || waitForToggleResponse}
			on:click={save}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	{/if}
{:else}
	<Checkbox size="l" class="mb-s" bind:checked id="checkbox-hhgnwjz">
		{$format('enable_motion_sensor', {
			default: 'Enable motion sensor',
		})}
	</Checkbox>

	<hr class="mb-m" />

	<MotionBlindTime bind:this={blindTime} bind:error disabled={!checked} {device} />
	<MotionDetectionOperatingMode bind:this={operatingMode} disabled={!checked} {device} />
	<MotionPulseCount bind:this={pulseCount} bind:error disabled={!checked} {device} />
	<MotionSensitivity disabled={!checked} bind:this={sensitivity} {device} />
	<Button size="m" width="full" loading={waitForResponse} disabled={error} on:click={save}>
		{$format('button_save', { default: 'Save' })}
	</Button>
{/if}
